import React from "react";

import { useAppSelector } from "../../../store/reducers";

interface IProps {
    title: string;
    first_name: string;
    last_name: string;
    line1: string;
    line2: string;
    line4: string;
    state: string;
    postcode: string;
    country: string;
}

export const Address = (props: IProps): React.ReactNode => {
    const countries = useAppSelector((state) => state.csr.countries);

    const country = countries.find((c) => c.url.includes(props.country));
    return (
        <p className="csr-address">
            {props.title || "-"}. {props.first_name || "-"}{" "}
            {props.last_name || "-"}
            <br />
            {props.line1 || "-"}
            <br />
            {props.line2 || "-"}
            <br />
            {props.line4 || "-"}, {props.state || "-"} {props.postcode || "-"}
            <br />
            {country ? country.printable_name : "-"}
        </p>
    );
};
